const DarkButton = (props) => {
  const { children, kind, size, customClass, ...otherProps } = props;

  let className =
    "relative whitespace-nowrap inline-block px-4 md:px-6 outline-none text-base rounded-xl md:rounded-2xl transition duration-200";
  className += size === "sm" ? " h-8" : size === "lg" ? " h-10" : " h-12";
  if (kind === "danger")
    className +=
      " bg-red-700 hover:bg-red-600 text-gray-50 dark:bg-red-600 dark:text-white active:bg-red-600 dark:hover:bg-red-500 dark:active:bg-red-500";
  else
    className +=
      " bg-gray-800 hover:bg-navy-600 text-gray-100 dark:bg-navy-600 dark:text-white active:bg-navy-700 dark:hover:bg-navy-700 dark:active:bg-navy-500 disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    <button {...otherProps} className={`${className} ${customClass}`}>
      {children}
    </button>
  );
};

export default DarkButton;
